import React from "react";
import { ClipboardCheck, Swords, Banknote, ArrowRight } from "lucide-react";
import { processSteps } from "../mock";

const iconMap = { ClipboardCheck, Swords, Banknote };

const Process = () => {
  return (
    <section id="how-it-works" className="bg-black py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-[#E11D26]" />
            <span className="text-[#E11D26] text-xs sm:text-sm font-bold tracking-[0.25em] uppercase">
              The Process
            </span>
          </div>
          <h2
            className="text-white text-4xl sm:text-5xl md:text-6xl font-black uppercase leading-[0.95]"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            Three Steps To <span className="text-[#E11D26]">Getting Paid</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-4 relative">
          {/* connecting line */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[2px] bg-gradient-to-r from-[#E11D26] via-[#E11D26]/50 to-[#E11D26]" />

          {processSteps.map((p, i) => {
            const Icon = iconMap[p.icon];
            return (
              <div key={i} className="relative">
                <div className="relative z-10 mx-auto h-24 w-24 rounded-full bg-[#E11D26] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(225,29,38,0.35)]">
                  <Icon className="h-10 w-10" strokeWidth={1.8} />
                </div>
                <div className="mt-6 bg-[#0F0F0F] border border-white/10 p-7 text-center">
                  <div className="text-[#E11D26] text-xs font-bold tracking-[0.3em] uppercase">
                    {p.step}
                  </div>
                  <h3
                    className="mt-2 text-white text-2xl font-black uppercase tracking-wide"
                    style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
                  >
                    {p.title}
                  </h3>
                  <p className="mt-3 text-white/65 text-sm leading-relaxed">
                    {p.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="group inline-flex items-center justify-center gap-3 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-8 py-4 transition-colors"
          >
            <span className="text-sm">Start Your Free Review</span>
            <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
